<template>
  <v-carousel
    v-model="model"
    cycle
    hide-delimiter-background
    :height="$vuetify.breakpoint.smAndDown ? '60vh' : '82vh'"
    :hide-delimiters="$vuetify.breakpoint.smAndDown"
  >
    <v-carousel-item
      v-for="(item, i) in banners"
      :key="i"
      :src="item.src"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data: () => ({
    model: 0,
    banners: [],
    items: {
      mobile: [
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fmobile%2Fbanner-mobile-1.jpeg?alt=media&token=22e9e083-a9ff-4bd4-b9dc-b55b0466fdb8",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fmobile%2Fbanner-mobile-2.jpeg?alt=media&token=b2dcd680-61a8-49e0-85b6-c3a0dc5ca678",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fmobile%2Fbanner-mobile-3.jpeg?alt=media&token=7aaaab0b-67cc-49cd-aa88-e545c169455a",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fmobile%2Fbanner-mobile-4.jpeg?alt=media&token=f86c07cc-56c9-4123-98fa-00841735fd51",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fmobile%2Fbanner-mobile-5.jpeg?alt=media&token=f877d1f3-048b-4fd3-8a21-110846bce330",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fmobile%2Fbanner-mobile-6.jpeg?alt=media&token=f2235c2d-2ae8-4efb-ab07-bdae0bb50761",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fmobile%2Fbanner-mobile-7.jpeg?alt=media&token=7cfcf11a-7e2a-49d6-853e-306c3d8bee81",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fmobile%2Fbanner-mobile-8.jpeg?alt=media&token=f3060805-1c3d-4e57-a85c-a89f805991de",
        },
      ],
      desktop: [
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fbanner-1.jpeg?alt=media&token=0bd4bdbe-e19b-4c27-9d62-97253b25ae4e",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fbanner-2.jpeg?alt=media&token=ee83ac06-2aeb-4c47-ad91-a767dbf5f5c1",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fbanner-3.jpeg?alt=media&token=6c7ad309-bc83-42c9-b2b3-8e0d6e4e3754",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fbanner-4.jpeg?alt=media&token=eb380315-ff0c-466a-9d5c-5f3c4c1bea99",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fbanner-5.jpeg?alt=media&token=e0c7ced6-952a-4dbe-ac87-c93e93582c86",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fbanner-6.jpeg?alt=media&token=680a4657-a16c-45d3-b891-df3540b56223",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fbanner-7.jpeg?alt=media&token=4a0c5458-7029-4652-9502-b5fc90443ac3",
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/picsncart-5772f.appspot.com/o/banners%2Fbanner-8.jpeg?alt=media&token=59fe6963-dc21-4c93-9c17-e6a91036b384",
        },
      ],
    },
  }),
  created() {
    this.banners = this.items.desktop;
    if (window.innerWidth <= 600) {
      this.banners = this.items.mobile;
    }
  },
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
}
</style>